import React from 'react';
import { useInput } from 'hooks';
import { A } from 'hookrouter';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {
  IconPopover,
  isValidAccountNumberLength,
  isValidCardNumberLength,
  isValidSSNLength,
  InvalidFeedback,
} from 'common';
import 'form.scss';
import { ReactComponent as Info } from 'images/info.svg';

const FindMemberForm = ({ forgot }) => {
  const inputValidation = (inputs) => {
    let errors = {};
    errors.memberNumber = !(
      isValidAccountNumberLength(inputs.memberNumber) || isValidCardNumberLength(inputs.memberNumber)
    );
    return errors;
  };

  const { inputs, handleInputChange, handleBlur, errors } = useInput(inputValidation);

  const fieldValidation = ({ memberNumber = '', partialSSN = '' }) =>
    (isValidAccountNumberLength(memberNumber) || isValidCardNumberLength(memberNumber)) && isValidSSNLength(partialSSN);

  const FormButton = ({ children, submittedFields }) => (
    <Form.Group controlId="formSubmit">
      <Button variant="occu-primary" type="submit" block disabled={!fieldValidation(submittedFields)}>
        {children || 'Submit'}
      </Button>
    </Form.Group>
  );

  return (
    <div className="occu-form occu-form-wide">
      <h4>LET'S FIND YOU</h4>
      <Form
        name="findMemberForm"
        id="findMemberForm"
        onSubmit={(event) => {
          forgot(inputs.memberNumber, inputs.partialSSN);
          event.preventDefault();
        }}
      >
        <Form.Group controlId="formNumber">
          <Form.Label>Account Number or Card Number</Form.Label>
          <IconPopover
            content="If you do not have an active Orange County's Credit Union Debit/ATM or Credit Card, enter your Orange County's Credit Union Member Number"
            title="Information"
          >
            <Info className="icon" />
          </IconPopover>
          <Form.Control
            type="text"
            name="memberNumber"
            onChange={(event) => {
              event.target.value = event.target.value.replace(/[^0-9]/g, '');
              handleInputChange(event);
            }}
            maxLength={16}
            value={inputs.memberNumber}
            isInvalid={errors.memberNumber}
            onBlur={handleBlur}
            autoComplete="off"
            required
          />
          <InvalidFeedback type="memberNumber" />
        </Form.Group>
        <Form.Group controlId="formSSN">
          <Form.Label>Last Four of SSN</Form.Label>
          <Form.Control
            type="password"
            name="partialSSN"
            onChange={(event) => {
              event.target.value = event.target.value.replace(/[^0-9]/g, '');
              handleInputChange(event);
            }}
            value={inputs.partialSSN}
            minLength={4}
            maxLength={4}
            required
            autoComplete="off"
          />
        </Form.Group>
        <FormButton submittedFields={inputs} />
      </Form>
      <h5>
        Already enrolled? <br />
        Click <A href="/mortgage/sign-in">here</A>
      </h5>
    </div>
  );
};

export { FindMemberForm };
